// extracted by mini-css-extract-plugin
export default {"skills":"styles_skills__HHXE1"};